<owl-carousel-o [options]="customOptions">
  <ng-container *ngFor="let item of bannerList; let i = index; trackBy: trackBySlide">
    <ng-template carouselSlide>
      <div class="banner-content">
        <!-- <img ngSrc="{{ item?.image ? fileDirectoriesPath + item?.image : 'assets/images/ic_level.svg' }}"
          alt="banner image" class="banner_image" onerror="this.ngSrc = 'assets/images/ic_level.svg'" fill priority
          fetchpriority="high" /> -->
        <img src="{{ item?.image ? fileDirectoriesPath + item?.image : 'assets/images/ic_level.svg' }}"
          alt="banner image" class="banner_image" onerror="this.src = 'assets/images/ic_level.svg'" priority />

        <div class="banner__content">
          <h1 class="banner__heading">{{ item?.title | titlecase }}</h1>
          <p class="banner_des">{{ item?.description | titlecase }}</p>
          @if (userLoggedIn && item?.redirectionURL) {
          <a class="common--button" [href]="item?.redirectionURL" target="_blank">Explore More</a>
          }
          @if (!userLoggedIn) {
          <a class="common--button" href="javascript:void(0)" (click)="triggerScroll()">Evaluate My Performance</a>
          }
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>